import axios from 'axios';

const apiAddress = async (lat,lng) => {
    console.log(lat,lng)
    try {
      const result = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&sensor=true&key=AIzaSyC8bJru_qVoe0XgT1xmBD7rygLVUxq7FwY`)
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }

  export {
      apiAddress
  }